

import { useState } from "react"
import { Header } from "../../../IndexPage/Header/Header"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Footer } from "../../../Footer/Footer"


export const Valuation = () => {

    const [ReadMoreText, setReadMoreText] = useState(false)

    const handleReadmore = () => {
        setReadMoreText(!ReadMoreText)
    }

    return (
        <>
         <div className="container-fluid">
            <div className="row" onLoad={() => window.scrollTo(0, 0)}>
                <div className="col-12">
                    <Header actives="Valuation" />
                    <HerosectionsAll ScreenName="Valuation" ScreenSearch="valuation" />
                    <div className="row p-2 p-lg-5" >

                        <div className="col-12 col-lg-12 py-3">
                            <div className="p-4 faint " style={{ position: 'relative',  textAlign: 'justify',  }}>
                                <h5 className="fw-bold gray_color pb-2">Valuation</h5>

                                <p>“Value” of the subject matter insured is having more significance in Marine insurance than any other branch of General Insurance. It is a fallacy that all marine insurance policies are "Agreed Value" policies!  </p>

                                <p>
                                    Dealing with Marine insurance i.e. Hull & Machinery and Cargo insurance, we have come across the following terms in reference to “Value”-
                                </p>

                                <p>
                                    Agreed value, Policy valuation, Insurable value, salved value (Salvage claims), contributory value (General Average Claims), Actual Value, Market Value, Value on Arrival at destination, Value when recovered (from loss), Value of the ship when repaired, gross sound value of goods, damage value of goods, total insured value, single valuation.
                                </p>

                                <p>
                                    Value of the vessels fluctuate like a stock prices listed on stock exchange!  Value of vessels depends upon inter alia on the freight rates. Decision in the case law regarding value of the vessel was: “The value of the ship is an estimate, or rough capitalization, of the earning power of the ship for its life” (Edison, The 1933).
                                </p>

                                {ReadMoreText && (
                                    <div>

                                        <p>
                                            Hence fixing the value for the subject matter insured, should be done meticulously with the assistance of the valuer to ensure that the subject matter of insurance is fully covered against the risks and underinsurance will not be applicable at the time of settlement of the claim.
                                        </p>
                                        <p>
                                            Value is fixed/re-fixed for newly built-up vessel, after major accidental repairs being done or at the funeral voyage. Fixing the value for ocean going Merchant ships having the database of statistics regarding new building prices, freight rates and second-hand prices and the sundry vessels like accommodation barge which is laid up and non- operational are two different things! The mortgagee may insure the vessel for the entire amount of its financial interest, even if this exceeds the vessel's market value.
                                        </p>
                                        <p>
                                            Our team of marine insurance industry experts, as well as management and cost accountant, provides valuation services to our clients.
                                        </p>
                                    </div>

                                )}

                                <p className="float-end read_more_btn pb-lg-3">
                                    <button className="btn button" onClick={handleReadmore}>
                                        <span>{ReadMoreText ? 'Read Less' : 'Read More'}</span>
                                    </button>
                                </p>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
            </div>
        </>
    )
}



